var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('va-select',{attrs:{"options":_vm.consents,"textBy":"consentTitle"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c('consent-grid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }